<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-row no-gutters align-content="start" justify="center">
      <v-card :width="mobileTrigger ? '100%' : '1280'" :key="refreshKey" class="pa-0">
        <v-col cols="12" sm="12" lg="12" class="pa-2 pb-0">
          <i-card-top
            class="d-md-flex"
            headerTitle
            :useBtnList="buttonUseList"
            @btnSave="btnSave()"
            @btnSearch="btnSearch(mainData)"
            @btnDelete="btnDelete()"
          >
            <template v-slot:body>
              <v-layout>
                <v-row no-gutters class="center pa-0 pa-md-2 pb-0"></v-row>
              </v-layout>
            </template>
          </i-card-top>
        </v-col>
        <v-col cols="12" sm="12" lg="12" class="pa-2 px-4 pb-0">
          <v-row no-gutters>
            <v-col cols="12">
              <i-card-vertical headerTitle="사업장 관리" :IsUseInnerAddition="true" device="web">
                <template v-slot:innerAddition>
                  <v-btn
                    color="primary"
                    small
                    elevation="0"
                    outlined
                    class="rounded"
                    @click="btnCancel()"
                  >
                    <v-icon left>mdi-exit-to-app</v-icon>목록으로
                  </v-btn>
                </template>
                <template v-slot:body>
                  <!-- v-form 시작 -->
                  <v-form ref="form" class="py-5">
                    <v-row>
                      <v-col cols="6">
                        <div class="form-label">고객 코드</div>
                        <v-text-field
                          ref="clntId"
                          v-model="editingData.clntId"
                          outlined
                          class
                          :rules="rules"
                          readonly
                        />
                      </v-col>
                      <v-col cols="6">
                        <div class="form-label">고객 명</div>
                        <v-text-field
                          ref="clntNm"
                          v-model="editingData.clntNm"
                          outlined
                          class
                          :rules="rules"
                          readonly
                        />
                      </v-col>
                      <v-col cols="6">
                        <div class="form-label">사업장 코드</div>
                        <v-text-field
                          ref="compId"
                          v-model="editingData.compId"
                          outlined
                          class
                          readonly
                        />
                      </v-col>
                      <v-col cols="6">
                        <div class="form-label">사업장 명</div>
                        <v-text-field
                          ref="compNm"
                          v-model="editingData.compNm"
                          outlined
                          class
                          :rules="rules"
                        />
                      </v-col>
                      <v-col cols="12">
                        <div class="form-label">대표자</div>
                        <v-text-field
                          ref="write"
                          v-model="editingData.rpstNm"
                          outlined
                          class
                          :rules="rules"
                        />
                      </v-col>
                      <v-col cols="6">
                        <div class="form-label">사업장등록번호</div>
                        <v-text-field
                          ref="rgstNo"
                          v-model="editingData.rgstNo"
                          outlined
                          class
                          :rules="rules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <div class="form-label">법인등록번호</div>
                        <v-text-field ref="corpNo" v-model="editingData.corpNo" outlined class></v-text-field>
                      </v-col>

                      <v-col cols="4">
                        <div class="form-label">업종코드</div>
                        <DxDropDownBox
                          class="hidden-sm-and-down"
                          ref="dropDownBoxRefBiz"
                          :value="editingData.detailCd"
                          placeholder="업종코드"
                          :drop-down-options="{ width: '100%' }"
                          :defer-rendering="false"
                          :data-source="bizList"
                          display-expr="detailCd"
                          value-expr="detailCd"
                        >
                          <div style="margin: 10px !important;">
                            <DxDataGrid
                              :data-source="bizList"
                              :hover-state-enabled="true"
                              :focused-row-enabled="true"
                              width="100%"
                              height="500px"
                              :word-wrap-enabled="true"
                              :show-row-lines="true"
                              :editing="{ allowUpdating: false }"
                              :selection="{ mode: 'single', deferred: false }"
                              :filter-row="{ visible: true }"
                              :on-content-ready="() => {}"
                              key-expr="detailCd"
                              @selection-changed="e => onBizChanged(e)"
                              :on-initialized="() => null"
                            >
                              <DxPaging :enabled="true" :page-size="5" />
                              <DxColumn data-field="detailCd" caption="업종코드" width="40%" />
                              <DxColumn data-field="detailNm" caption="업종명" width="40%" />
                            </DxDataGrid>
                          </div>
                        </DxDropDownBox>
                      </v-col>
                      <v-col cols="8">
                        <div class="form-label">업종명</div>
                        <v-text-field
                          ref="detailNm"
                          v-model="editingData.detailNm"
                          outlined
                          class
                          :rules="rules"
                          readonly
                        />
                      </v-col>

                      <v-col cols="12">
                        <div class="form-label">우편번호</div>
                        <DxDropDownBox
                          v-model="editingData.zipCd"
                          :displayExpr="setPostCd"
                          ref="postCdDropBoxRef"
                          :drop-down-options="{ width: 350 }"
                          @opened="onOpened"
                          @closed="onClosed"
                          content-template="contentTemplate"
                        >
                          <template #contentTemplate="{}">
                            <vue-daum-postcode
                              v-if="postVisible"
                              style="height: 500px; overflow: scroll;"
                              q
                              :animation="false"
                              :no-shorthand="true"
                              :no-auto-mapping="true"
                              :please-read-guide="1"
                              :please-read-guide-timer="1"
                              :max-suggest-items="3"
                              :show-more-h-name="false"
                              :hide-map-btn="true"
                              :hide-eng-btn="true"
                              :always-show-eng-addr="true"
                              :zonecode-only="true"
                              :theme="{
                                outlineColor: '#44444'
                              }"
                              @complete="setAddress"
                            />
                          </template>
                        </DxDropDownBox>
                      </v-col>

                      <v-col cols="6">
                        <div class="form-label">주소</div>
                        <v-text-field ref="addrs1" v-model="editingData.addrs1" outlined class></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <div class="form-label">상세주소</div>
                        <v-text-field ref="addrs2" v-model="editingData.addrs2" outlined class></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <div class="form-label">주소(영문)</div>
                        <v-text-field ref="addrsEn1" v-model="editingData.addrsEn1" outlined class></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <div class="form-label">상세주소(영문)</div>
                        <v-text-field ref="addrsEn2" v-model="editingData.addrsEn2" outlined class></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <div class="form-label">전화번호</div>
                        <v-text-field ref="telNo" v-model="editingData.telNo" outlined class></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <div class="form-label">팩스번호</div>
                        <v-text-field ref="faxNo" v-model="editingData.faxNo" outlined class></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <div class="form-label">국가코드</div>
                        <v-select
                          height="32"
                          v-model="editingData.natnCd"
                          :items="natnList"
                          dense
                          item-text="minorNm"
                          item-value="minorCd"
                          outlined
                          class
                        >
                          <template v-slot:selection="{ item }">
                            <div class="text-center">{{ item.minorNm }}</div>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content @click="$emit('click', item.minorCd)">
                              <v-list-item-title>{{ item.minorNm }}</v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="6">
                        <div class="form-label">이메일</div>
                        <v-text-field ref="email" v-model="editingData.email" outlined class></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <div class="form-label">은행코드</div>
                        <v-text-field ref="bankCd" v-model="editingData.bankCd" outlined class></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <div class="form-label">계좌번호</div>
                        <v-text-field ref="bankNo" v-model="editingData.bankNo" outlined class></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <div class="form-label">직인</div>
                        <div v-if="editingData.seal">
                          <svg-icon
                            class="jpg_icon mr-2"
                            v-if="editingData.seal == 'jpg' || editingData.seal == 'jpeg'"
                            icon-class="jpg"
                            style="height: 1rem;"
                          />

                          <svg-icon
                            class="png_icon mr-2"
                            v-else-if="editingData.seal == 'png'"
                            icon-class="png"
                            style="height: 1rem;"
                          />

                          <svg-icon
                            class="file_default_icon ml-2"
                            v-else
                            icon-class="file_default"
                            style="height: 1rem;"
                          />
                          <span>{{ editingData.sealFileNm }}</span>
                          <v-btn class="ml-2" icon role="clear" x-small @click="clearClick('seal')">
                            <svg-icon icon-class="close"></svg-icon>
                          </v-btn>
                          <v-btn
                            elevation="0"
                            color="btn_sub"
                            dark
                            x-small
                            class="pa-1 ml-2 mr-2"
                            role="upload"
                            @click="downloadClick('seal')"
                          >다운로드</v-btn>
                        </div>
                        <div v-else>
                          <v-btn
                            elevation="0"
                            color="btn_sub"
                            dark
                            x-small
                            class="pa-1 ml-2 mr-2"
                            role="upload"
                            @click="uploadClick('seal')"
                          >업로드</v-btn>
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div class="form-label">로고</div>
                        <div v-if="editingData.logo">
                          <svg-icon
                            class="jpg_icon mr-2"
                            v-if="editingData.logo == 'jpg' || editingData.logo == 'jpeg'"
                            icon-class="jpg"
                            style="height: 1rem;"
                          />

                          <svg-icon
                            class="png_icon mr-2"
                            v-else-if="editingData.logo == 'png'"
                            icon-class="png"
                            style="height: 1rem;"
                          />

                          <svg-icon
                            class="file_default_icon ml-2"
                            v-else
                            icon-class="file_default"
                            style="height: 1rem;"
                          />
                          <span>{{ editingData.logoFileNm }}</span>
                          <v-btn class="ml-2" icon role="clear" x-small @click="clearClick('logo')">
                            <svg-icon icon-class="close"></svg-icon>
                          </v-btn>
                          <v-btn
                            elevation="0"
                            color="btn_sub"
                            dark
                            x-small
                            class="pa-1 ml-2 mr-2"
                            role="upload"
                            @click="downloadClick('logo')"
                          >다운로드</v-btn>
                        </div>
                        <div v-else>
                          <v-btn
                            elevation="0"
                            color="btn_sub"
                            dark
                            x-small
                            class="pa-1 ml-2 mr-2"
                            role="upload"
                            @click="uploadClick('logo')"
                          >업로드</v-btn>
                        </div>
                      </v-col>

                      <v-col cols="12">
                        <div class="form-label">설명</div>
                        <v-textarea
                          ref="desc"
                          v-model="editingData.desc"
                          no-resize
                          outlined
                          class
                          auto-grow
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-form>
                </template>
              </i-card-vertical>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import notify from 'devextreme/ui/notify'
import iCardVertical from '@/components/common/iCardVertical.vue'
import DxDateBox from 'devextreme-vue/date-box'
import DxDropDownBox from 'devextreme-vue/drop-down-box'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import { getBizList, getClientList } from '@/api/setting/clientManage'
import { multiUpload, downloadFile, getFile } from '@/api/baseManage/fileUpload'
import { getCompanyList, saveCompany, deleteCompany } from '@/api/baseManage/compManage'
import { getCommonCode } from '@/api/common/commonApi'
import { getExtension } from '@/utils/common.js'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    'i-card-top': iCardTop,
    'i-card-vertical': iCardVertical,
    DxDateBox,
    DxDropDownBox
  },
  data() {
    return {
      rules: [
        value => {
          if (value) return true
          return '필수입력 값입니다.'
        }
      ],
      buttonUseList: [
        'btnSearch', //조회
        'btnSave', //저장
        'btnDelete' //삭제
      ],
      editingData: {},
      bizList: [],
      clientList: [],
      natnList: [],
      mainData: {},
      allowedFileExtensions: ['jpg', 'jpeg', 'gif', 'png'],
      postVisible: false
    }
  },
  created() {},
  beforeMount() {},
  mounted() {
    if (!this.$route.params.data) {
      this.$router.go(-1)
      return
    }

    if (!this.$route.params.data.__created__) {
      this.mainData = this.$route.params.data
      this.btnSearch(this.mainData)
    }
  },
  watch: {},
  computed: {
    mobileTrigger: function() {
      return this.width < 800
    }
  },
  async activated() {
    await this.setLookup()
    if (this.$route.params.data) {
      this.mainData = this.$route.params.data
      if (this.mainData.__created__) {
        this.initializeData()
      } else {
        this.btnSearch(this.mainData)
      }
    }
  },
  methods: {
    initializeData() {
      this.editingData = {
        clntId: this.getClntId(),
        compId: '',
        clntNm: this.clientList.find(element => element.clntId == this.getClntId()).clntNm,
        natnCd: 'KR',
        detailNm: '',
        addrs1: '',
        addrsEn1: '',
        seal: '',
        logo: '',
        __created__: true
      }
    },
    btnSearch(params) {
      this.openLoading()
      console.log('[request] getCompanyList()', params)

      getCompanyList(params, true)
        .then(response => {
          if (response.success) {
            if (response.list.length > 0) {
              this.editingData = response.list[0]
            } else {
              this.initializeData()
            }
          }
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnSave() {
      const validate = this.$refs.form.validate()

      if (!validate) {
        this.vToastify(this.$t('저장 입력 항목을 확인해주세요.'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        async current => {
          this.openLoading()

          this.editingData.compNm = this.editingData.compNm.trim()
          this.editingData.rpstNm = this.editingData.rpstNm.trim()
          console.log('[request] saveCompany()', this.editingData)
          saveCompany(this.editingData)
            .then(response => {
              console.log('[response] saveCompany()', response)
              if (response.success) {
                if (this.editingData.__created__) {
                  this.editingData.compId = response.map.compId
                  this.mainData = response.map
                }
                if (
                  (this.editingData.sealFile != null && this.editingData.sealFile != '' && this.editingData.seal__fileUpdate__) ||
                  (this.editingData.logoFile != null && this.editingData.logoFile != '' && this.editingData.logo__fileUpdate__)
                ) {
                  this.saveFile(this.editingData).then(() => {
                    this.btnSearch(this.mainData)
                  })
                } else {
                  this.btnSearch(this.mainData)
                }
              }
            })
            .finally(() => {
              notify(this.$t('저장되었습니다.'), 'success', 1000)
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    btnDelete() {
      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        async current => {
          this.openLoading('deleting')
          console.log('[request] deleteCompany()', this.editingData)
          //삭제 api
          deleteCompany([this.editingData], true)
            .then(res => {
              if (res.success) {
                this.$router.go(-1)
              }
            })
            .catch(error => {})
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    btnCancel() {
      this.vToastifyPrompt(this.$t('작성을 중지하고 이전 페이지로 이동하시겠습니까?'), 'info', async current => {
        this.$router.go(-1)
        return
      })
    },
    saveFile(element) {
      return new Promise((resolve, reject) => {
        let promises = []
        // string변환된 파일을 다시 File 객체로
        if (element.sealFile != null && element.sealFile != '') {
          // form 데이터로 전송
          let formData = new FormData()

          formData.append('files[]', element.sealFile)

          let fileVO = {
            clntId: element.clntId,
            targetId: element.clntId + '_' + element.compId + '_seal',
            targetType: '00003',
            useYn: 'Y'
          }

          formData.append('FileVO', new Blob([JSON.stringify(fileVO)], { type: 'application/json' }))
          promises.push(
            multiUpload(formData, false).then(() => {
              notify(this.$t('Save.success'), 'success', 300)
            })
          )
        }
        if (element.logoFile != null && element.logoFile != '') {
          // form 데이터로 전송
          var formData = new FormData()
          formData.append('files[]', element.logoFile)

          let fileVO = {
            clntId: element.clntId,
            targetId: element.clntId + '_' + element.compId + '_logo',
            targetType: '00003',
            useYn: 'Y'
          }

          formData.append('FileVO', new Blob([JSON.stringify(fileVO)], { type: 'application/json' }))
          promises.push(
            multiUpload(formData, false).then(() => {
              notify(this.$t('Save.success'), 'success', 300)
            })
          )
        }
        Promise.all(promises).then(() => {
          resolve(true)
        })
      })
    },
    //dropDown이 열릴때 타는 이벤트
    onOpened() {
      this.postVisible = true
    },
    //dropDown이 닫힐때 타는 이벤트
    onClosed() {
      this.postVisible = false
    },
    setPostCd() {
      return this.$refs.postCdDropBoxRef.value
    },
    clearClick(type) {
      this.editingData[`${type}__fileUpdate__`] = true
      this.editingData[`${type}`] = null
      this.editingData[`${type}FileNm`] = null
    },
    downloadClick(type) {
      //올리지 않은 상태로 파일을 다운로드 받는 경우
      if (this.editingData[`${type}File`] != null && this.editingData[`${type}File`] !== '') {
        let link = document.createElement('a')
        let objectUrl = window.URL.createObjectURL(this.editingData[`${type}File`])
        link.href = objectUrl
        link.download = this.editingData[`${type}FileNm`] + '.' + this.editingData[`${type}`]
        link.click()
      } else {
        let params = {
          clntId: this.getClntId(),
          targetType: '00003',
          targetId: type + '_' + this.editingData.clntId + '_' + this.editingData.compId
        }

        getFile(params).then(response => {
          if (response.list) {
            let params = {
              clntId: response.list[0].clntId,
              writeDt: response.list[0].writeDt,
              docNo: response.list[0].docNo
            }
            downloadFile(params)
              .then(res => {
                let link = document.createElement('a')
                // 객체를 만들어서 생성
                let objectUrl = window.URL.createObjectURL(res)
                link.href = objectUrl
                link.download = `${response.list[0].fileNm}.${response.list[0].extension}`
                link.click()
              })
              .finally(() => this.endLoading())
          } else {
            this.endLoading()
          }
        })
      }
    },
    uploadClick(type) {
      let input = document.createElement('input')
      input.type = 'file'
      input.click()

      input.addEventListener('change', event => {
        const file = event.target.files[0]

        let subFileName = getExtension(file.name)

        let index = this.allowedFileExtensions.findIndex(element => element == subFileName[1])

        if (index < 0) {
          notify(this.$t('업로드할 수 없는 확장자입니다.'), 'error', 3000)
          return
        }

        this.editingData[`${type}`] = subFileName[1]
        this.editingData[`${type}FileNm`] = subFileName[0]
        this.editingData[`${type}File`] = file
        this.editingData[`${type}__fileUpdate__`] = true
      })
    },
    onValueChanged(event) {
      // 날짜 세팅
      const date = new Date(event.value)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const dateFormat = `${year}.${month}.${day}`

      // editingData에 dateFormat 할당 예시
      this.editingData.dateFormat = dateFormat
    },
    onBizChanged(event) {
      this.$refs.dropDownBoxRefBiz.instance.option('value', event.selectedRowKeys)
      this.editingData.detailCd = event.selectedRowsData[0].detailCd
      this.editingData.detailNm = event.selectedRowsData[0].detailNm
      this.$refs.dropDownBoxRefBiz.instance.close()
    },
    setAddress(e) {
      //선택된 우편번호에 대한 정보를 설정
      this.editingData.zipCd = e.zonecode
      this.editingData.addrs1 = e.address
      this.editingData.addrsEn1 = e.addressEnglish
      this.$refs.postCdDropBoxRef.instance.close()
    },
    async setLookup() {
      await Promise.all([getBizList(), getCommonCode('CM003'), getClientList({ validOnly: true })]).then(response => {
        this.bizList = response[0].list
        this.natnList = response[1].list
        this.clientList = response[2].list
      })
    }
  }
}
</script>

<style lang="scss"></style>
